import * as T from '@/types'
import { Paginator } from '@/api/paginator'
import { AxiosPromise } from 'axios'
import JSONAPIDeserializer from 'ts-jsonapi'

export interface CrudResource<Entity extends T.Entity> {
    all (): Promise<Paginator<Entity>>
    find (id: T.EntityId): Promise<Entity>
    page (pageRoute: string): Promise<Paginator<Entity>>
    store (item : Partial <Entity>): Promise<Entity>
    update (item : Entity) : Promise<Entity>
    upsert (item: Partial<Entity>): Promise<Entity>
    archive (item: Entity): Promise<Entity>
    unarchive (item: Entity): Promise<Entity>
}

export interface CrudBaseCalls<Entity> {
    index (filters?: T.Filters, queryParams?: any): AxiosPromise<any>
    page (pageRoute: string, filters?: T.Filters): AxiosPromise<any>
    show (id: T.EntityId, filters? : T.Filters) : AxiosPromise<any>
    // store (entity: Partial<Entity>): AxiosPromise<any>
    // update (entity: Entity): AxiosPromise<any>
    // delete (entity: Entity): AxiosPromise<any>
    // restore? (entity: Entity): AxiosPromise<any>
}

export abstract class CrudResource<Entity extends T.Entity> implements CrudResource<Entity> {
    api: T.CreditorDeskApi
    deserializer = new JSONAPIDeserializer.Deserializer({keyForAttribute: 'camelCase'})

    constructor (api: T.CreditorDeskApi) {
        this.api = api
    }

    protected abstract get crudBaseCalls (): CrudBaseCalls<Entity>
    protected abstract items (responseData: any): any[]
    protected abstract item (responseData: any): any
    protected abstract map (data: any) : Entity

    async all (filters?: T.Filters, queryParams?: any): Promise<Paginator<Entity>> {
        const response = await this.crudBaseCalls.index(filters, queryParams)
        const entities = this.deserializer.deserialize(response.data)
        console.log('entities', entities)

        return new Paginator(entities, {...response.data.links, ...response.data.meta})
    }

    async page (pageRoute: string, filters?: T.Filters): Promise<Paginator<Entity>> {
        const response = await this.crudBaseCalls.page(pageRoute, filters)
        const entities = this.deserializer.deserialize(response.data)

        return new Paginator(entities, {...response.data.links, ...response.data.meta})
    }
    
    async find (id: T.EntityId, filters?: T.Filters): Promise<Entity> {
        const response = await this.crudBaseCalls.show(id, filters)
        const entities: Entity[] = this.deserializer.deserialize(response.data)
        
        return entities[0]
    }

    // async store (entity: Partial<Entity>) : Promise<Entity> {
    //     const response = await this.crudBaseCalls.store(entity)
    //     return this.map(this.item(response.data.data))
    // }

    // async update (entity: Entity) : Promise<Entity> {
    //     const response = this.crudBaseCalls.update(entity)
    //     return this.map(this.item(response.data.data))
    // }

    // async upsert (entity : Entity) : Promise<Entity> {
    //     if (entity.id) {
    //         return await this.update(entity)
    //     }
    //     return await this.store(entity)     
    // }

    // async archive (entity: Entity): Promise<Entity> {
    //     const response = await this.crudBaseCalls.delete(entity)
    //     return this.map(this.item(response.data.data))
    // }

    // unarchive (entity: Entity): Promise<Entity> {
    //     if (!this.crudBaseCalls.restore) {
    //         throw 'No restore on resource'
    //     }
    //     const response = await this.crudBaseCalls.restore(entity)
    //     return this.map(this.item(response.data.data))
    //     // return new Promise((resolve, reject) => {
    //     //     if (!this.crudBaseCalls.restore) {
    //     //         reject()
    //     //         return
    //     //     }
    //     //     this.crudBaseCalls.restore(entity)
    //     //         .then((response) => {
    //     //             resolve(this.map(this.item(response.data.data)))
    //     //         })
    //     //         .catch(reject)
    //     // })
    // }
}

export default CrudResource
